module.exports = __webpack_public_path__ + "img/ssd.008672cc.jpg";